import { Injectable } from "@angular/core";
import { FileLogger } from "@comunicare/comunicare-helper";
import { ICoding, IIdentifier, IRelatedPerson, Reference } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { concatMap, first } from "rxjs/operators";
import { RelatedHelper } from "../helpers/relatedHelper";
import { RelatedApiService } from "./api/related-api.service";
import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class RelatedService {
  constructor(private relatedApiService: RelatedApiService, private userService: UserService) {}

  public create(
    patient: Reference,
    firstname: string,
    lastname: string,
    mail: string,
    phone: string,
    birthdate: string,
    relationship?: ICoding[],
    reqParams?: Record<string, string | boolean>
  ): Observable<IRelatedPerson> {
    const related = RelatedHelper.asRelatedPerson(patient, firstname, lastname, mail, phone, birthdate, relationship, true);
    return this.relatedApiService.create(related, reqParams);
  }

  public getPatientRelateds(patientId: string): Observable<IRelatedPerson[]> {
    const routeName = this.relatedApiService.readRoutes[0];
    return this.userService.isAuthorized(routeName, "GET").pipe(
      first(),
      concatMap((isAuth) => {
        if (!isAuth) {
          FileLogger.warn("RelatedService", "User does not have access to: GET " + routeName);
          return of([]);
        }
        return this.relatedApiService.getPatientRelateds(patientId);
      })
    );
  }

  public update(
    identifier: IIdentifier,
    patient: Reference,
    isActive: boolean,
    firstname: string,
    lastname: string,
    mail: string,
    phone: string,
    birthdate: string,
    relationship?: ICoding[]
  ): Observable<IRelatedPerson> {
    const related = RelatedHelper.asRelatedPerson(patient, firstname, lastname, mail, phone, birthdate, relationship, isActive);
    related.identifier = identifier;
    return this.relatedApiService.update(related);
  }
}
